// APP_LOGO_2810 (GROK2 28/10): logo real do app (mesma fonte do DashboardQuickTestGrid), cai pras iniciais se a imagem falhar.
import React, { useState } from 'react';
import { API_BASE_URL } from '../apiBase';
import { cn } from '../lib/utils';

export default function AppLogo2810({ app, className, textClass }) {
  const [ok, setOk] = useState(true);
  const u = app?.logo_url;
  const logo = u && ok ? (u.startsWith('http') ? u : `${API_BASE_URL}${u}`) : null;
  return (
    <span className={cn('flex items-center justify-center overflow-hidden rounded-xl', className)} style={logo ? undefined : { background: app?.color }}>
      {logo ? <img src={logo} alt="" className="h-full w-full object-contain" loading="lazy" decoding="async" onError={() => setOk(false)} />
        : <span className={cn('font-bold tracking-wide text-white', textClass || 'text-sm')}>{app?.initials}</span>}
    </span>
  );
}
